export default [
  {
    path: '/dashboard',
    name: 'dashboard',
    redirect: {
      name: 'report.dashboard',
    },
    component: {
      render(c) {
        return c('router-view');
      },
    },
    meta: {
      breadcrumb: 'Dashboard',
      menuOptions: {
        title: 'Dashboard',
        description: 'En esta sección podrá ver las estadísticas de su empresa y UNILINK',
      },
    },
    children: [
      {
        path: '',
        name: 'report.dashboard',
        component: () => import('@/pages/supplier/reports/new_dashboard/NewDashboard'),
        meta: {
          breadcrumb: 'Dashboard',
        },
      },
      {
        path: 'details/:type',
        name: 'report.details',
        component: () => import('@/pages/supplier/reports/new_dashboard/ReportDetails'),
        meta: {
          breadcrumb: 'Details',
        },
      },
    ],
  },
  {
    path: '/TermsAndConditions',
    name: 'terms-conditions',
    component: () => import('@/pages/supplier/terms/TermsForSupplier'),
    meta: {
      layout: 'blank',
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/routes/publicPaths.js